import { data, statistics } from "..";
import TradingViewChart from "../../../../components/TradingViewChart";
import { AlternatingRows } from "./alternating-rows";
import { ValueRowsWithHeading } from "./values-with-heading";
import profile from "../../../../assets/images/Carousel/s1.jpg";
import { useState, useEffect } from "react";
import { demoSingleStock } from "../../../../services/demoaccount";
import { useParams } from "react-router-dom/cjs/react-router-dom";

export const Overview = () => {
  const { id } = useParams();
  const [stockData, setStockData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        if (id) {
          const data = await demoSingleStock(id); // Using PIBTL as example symbol
          setStockData(data.data);
        }
      } catch (error) {
        console.error("Error fetching stock data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStockData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <div className="grid-2">
        <div className="overview-card">
          {/* Row 1: Profile + Market Cap */}
          <div className="overview-row">
            <div className="overview-left">
              <img
                src={profile}
                alt="Profile"
                className="overview-profile-pic"
              />
              <div className="overview-text">
                <div className="overview-name">
                  {stockData?.SYMBOL || "PIBTL"}
                </div>
                <div className="overview-label">Tech & Communication</div>
              </div>
            </div>
            <div className="overview-cap">
              <div className="overview-label">Market Cap.:</div>
              <div className="overview-value">4.0596B</div>
            </div>
          </div>

          {/* Row 2: Price & Volume Info */}
          <div className="overview-row extra-details">
            {/* Column 1 */}
            <div className="overview-subcol">
              <div
                className={`${
                  stockData?.COLOR === "GREEN" ? "green-bg" : "red-bg"
                }`}
              >
                {stockData?.PRICE || "9.55"}
              </div>
              <div
                className={`colored ${
                  stockData?.COLOR === "GREEN" ? "green-text" : "red-text"
                }`}
              >
                {stockData?.CHANGE || "0.82"} (
                {stockData?.COLOR === "GREEN" ? "+" : "-"}%)
              </div>
              <div className="colored red-text">L: 1.26 H: 1.30</div>
              <div className="colored light-yellow">Avg Price: 1.27</div>
            </div>

            {/* Column 2 */}
            <div className="overview-subcol">
              <div className="colored">
                <span className="label-black">Last Trade Vol:</span>{" "}
                <span className="light-yellow">3.000</span>
              </div>
              <div className="colored">
                <span className="label-black">Last Three Trade:</span>{" "}
                <span className="light-yellow">16, 41.48</span>
              </div>
              <div className="colored">
                <span className="label-black">Total Volume:</span>{" "}
                <span className="light-yellow">
                  {stockData?.VOLUME
                    ? Number(stockData.VOLUME).toLocaleString()
                    : "58,781,898"}
                </span>
              </div>
              <div className="colored">
                <span className="label-black">Total Traders:</span>{" "}
                <span className="light-yellow">672</span>
              </div>
              <div className="colored">
                <span className="label-black">Upper Cap:</span>{" "}
                <span className="green-text">2.25</span>
              </div>
              <div className="colored">
                <span className="label-black">Lower Lock:</span>{" "}
                <span className="red-text">0.25</span>
              </div>
            </div>
          </div>
        </div>
        <div className="overview-card">
          {/* Row 1: Two Counters */}
          <div className="overview-row">
            <div className="counter-box">
              <div className="counter-value">{stockData?.PRICE || "9.55"}</div>
              <div className="counter-label">Current Price</div>
            </div>
            <div className="counter-box">
              <div className="counter-value">{stockData?.CHANGE || "0.82"}</div>
              <div className="counter-label">Price Change</div>
            </div>
          </div>

          {/* Optional: Additional Rows */}
          <div className="overview-row extra-details">
            <div className="overview-subcol">
              <div className="colored">
                <span className="label-black">Peak Traffic:</span>{" "}
                <span className="light-yellow">2,305</span>
              </div>
              <div className="colored">
                <span className="label-black">Avg Session:</span>{" "}
                <span className="light-yellow">5.2 mins</span>
              </div>
            </div>
            <div className="overview-subcol">
              <div className="colored">
                <span className="label-black">Bounce Rate:</span>{" "}
                <span className="red-text">27%</span>
              </div>
              <div className="colored">
                <span className="label-black">Conversions:</span>{" "}
                <span className="green-text">5.8%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TradingViewChart />
      <ValueRowsWithHeading values={statistics} />
      <AlternatingRows data={data} heading={"Hello world"} />
    </>
  );
};
